import { axiosPut } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';
import { UpdateCoinTypeRequest } from '@/types/stake-db';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 코인타입 수정
export const updateCoinType = async (data: UpdateCoinTypeRequest) => {
  const { coinTypeId, ...bodyWithoutId } = data;
  const payload: EndpointPayload = {
    path: `/assetfi/admin/staking/coin-types/${coinTypeId}`,
    body: bodyWithoutId,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'updateCoinType', axiosPut);
};
